import React from 'react'

export type TabContentProps = {
  children?: React.ReactNode
  className?: string
  fixed?: boolean
  id?: string
  text?: string
  selected?: boolean
  style?: React.CSSProperties
}

export const TabContent = ({ children, id, ...rest }: TabContentProps) => <div {...rest}>{children}</div>
